enum Verticals {
  Apparel_Women = 'Apparel_Women',
  Jewelry_and_Watches = 'Jewelry_and_Watches',
  Bicycle = 'Bicycle',
  Apparel_Men = 'Apparel_Men',
  Electronics = 'Electronics',
  Toys = 'Toys',
  Apparel_Children = 'Apparel_Children',
  Apparel_General = 'Apparel_General',
  Car_Dealerships = 'Car_Dealerships',
  Health_and_Beauty = 'Health_and_Beauty',
  Home_Furnishings_and_Decor = 'Home_Furnishings_and_Decor',
  Music_Equipment = 'Music_Equipment',
  Med_Spa = 'Med_Spa',
  Medical_Office = 'Medical_Office',
  Hospital_Health_System = 'Hospital_Health_System',
  Eye_Technology = 'Eye_Technology',
  Medical_Devices = 'Medical_Devices',
  Cameras_and_Photography = 'Cameras_and_Photography',
  Sports_Equipment = 'Sports_Equipment',
  Car_Audio = 'Car_Audio',
  Eyewear = 'Eyewear',
  Motorsports_Parts_and_Services = 'Motorsports_Parts_and_Services',
  Home_and_Garden = 'Home_and_Garden',
  Cars_Aftermarket = 'Cars_Aftermarket',
  Department_Store = 'Department_Store',
  Furniture = 'Furniture',
  Pawn_Shops = 'Pawn_Shops',
  Pet_Store = 'Pet_Store',
  Veterinary = 'Veterinary',
  Dental = 'Dental',
  Car_Services = 'Car_Services',
  Bookstore = 'Bookstore',
  Education = 'Education',
  Home_Services = 'Home_Services',
  Checkout_Platform = 'Checkout_Platform',
  Other = 'Other'
}

export default Verticals;
